import * as React from 'react';
import { Provider } from 'mobx-react';
import { configure } from 'mobx';
import { TargetingAdminStore } from './stores';
import { TargetingAdmin } from './TargetingAdmin';

export interface ITargetingAdminProps {
  token: string;
  tenant: string;
  // apiUrl:string;
  environment?: "Development" | "Test" | "Production";
  language?: "Danish" | "English" | "Swedish" | "German" | "Portuguese";
  appsInstances: {[key: string]: Array<{id?: number, title: string, instance: string}> };
  showAddFieldButton?: boolean;
  // highlightColor: string;
}

export class IATargetingAdmin extends React.Component<ITargetingAdminProps> {

  private targetingStore: TargetingAdminStore;
  

  constructor(props: ITargetingAdminProps) {
    super(props);
    this.targetingStore = new TargetingAdminStore();
    configure({
      isolateGlobalState: true,
      enforceActions: "never"
    });
    this.targetingStore.token = props.token;
    this.targetingStore.tenant = props.tenant;
    this.targetingStore.environment = props.environment;
    this.targetingStore.language = props.language;
    this.targetingStore.selectedTab = "UserGroups";
    this.targetingStore.showAddButton = props.showAddFieldButton;
    // this.targetingStore.apiUrl = props.apiUrl;
    this.targetingStore.instancesList = props.appsInstances;
    // this.targetingStore.highlightColor = props.highlightColor;
  }

  public componentWillReceiveProps(props: ITargetingAdminProps) {
    if (props != this.props) {
      this.targetingStore.token = props.token;
      this.targetingStore.language = props.language;
      this.targetingStore.instancesList = props.appsInstances;
    }
  }

  public render(): JSX.Element {
    return (
      <Provider targetingStore={this.targetingStore}>
        <TargetingAdmin />
      </Provider>
    );
  }
}